import styled from 'styled-components';
import React, {Fragment} from 'react';
import MotifChip from '@ey/motif-react-wrapper/Chip';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';
import {SVGICONS} from '@ey/icons';
import {StackedBarChart} from '@ey/canvascoreservices';
import theme from '@ey/styled-theme';
import {labels} from '../../../../util/utils';
import {getPercent} from '@ey/utils';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';
import {ViewTypes} from '../../../../util/uiconstants';

class TemplateCardConfig {
	constructor({
		title,
		hasCounterSection = true,
		customSection = false,
		counterSummary = new Map(),
		isLoading = false,
		className = '',
		onArrowClick,
		headerChildren = null,
		colabCount = false,
		colabComponent = false
	}) {
		this.title = title;
		this.hasCounterSection = hasCounterSection;

		this.isLoading = isLoading;
		this.customSection = customSection;

		this.className = className;
		this.onArrowClick = onArrowClick;
		this.headerChildren = headerChildren;
		this.colabCount = colabCount;
		this.colabComponent = colabComponent;

		if (this.hasCounterSection) {
			this.counterSummary = counterSummary;
			if (this.counterSummary.size === 0) {
				this.addCounter(
					new TemplateCardCounter({
						counterId: ViewTypes.tasks,
						totalCountLabel: labels.totalTasksLabel,
						counterDetails: [
							new CountDetail(labels.openLabel, 0),
							new CountDetail(labels.inProgress, 0),
							new CountDetail(labels.inreviewLabel, 0),
							new CountDetail(labels.CompleteLabel, 0)
						]
					})
				);
			}
		}
	}

	get hasCustomSection() {
		return this.customSection !== false;
	}
	get hasColabSection() {
		return this.colabCount !== false;
	}

	get hasRelateRequestSection() {
		return this.colabComponent !== false;
	}

	getCounterSummaryComponent(id) {
		const counter = this.counterSummary.get(id);
		if (counter !== undefined) {
			return counter.getCounterComponent;
		}
		return false;
	}
	getCounterDetailComponent(id) {
		const counter = this.counterSummary.get(id);
		if (counter !== undefined) {
			return counter.getCounterDetailComponent;
		}
		return false;
	}

	getCounterDetailComponents(id) {
		const counters = this.counterSummary.get(id);
		let components = [];
		if (counters !== undefined) {
			counters.forEach((counter) => components.push(counter.getCounterDetailComponent));
			return components;
		}
		return false;
	}
	// get getCounterComponents() {
	// 	let components = [];
	// 	this.counterSummary.forEach((value, key) => {
	// 		components.push(value.component);
	// 	});

	// 	return components;
	// }
	getColabCountComponent() {
		return (
			<>
				{/* <Divider /> */}
				{this.colabCount > 0 && this.hasColabSection !== false ? (
					<span className="request-count">
						<section className="request-number">{this.colabCount}</section>
						<section>{labels.Overdue}</section>
					</span>
				) : null}
			</>
		);
	}

	getRelateRequestComponent() {
		return (
			this.hasRelateRequestSection !== false && <section className="colab-component">{this.colabComponent}</section>
		);
	}

	addCounter(counter) {
		this.counterSummary.set(counter.counterId, counter);
	}

	updateCounters(counterId, counterDetails = []) {
		if (counterId === undefined) {
			return;
		}
		let counter = this.counterSummary.get(counterId);
		if (counter) {
			counterDetails.forEach((a, i) => {
				if (a !== null || a !== undefined) {
					counter.counterDetails[i].count = a;
				}
			});
			this.counterSummary.set(counterId, counter);
		}
	}

	setIsLoading(a) {
		this.isLoading = a;
	}

	addCounterSectionElement(component, detailComponent) {
		this.hasCounterSection = true;
		this.counterSummary.push({component: component, detailComponent: detailComponent});
	}
}

export default TemplateCardConfig;

export class TemplateCardCounter {
	constructor({
		counterId,
		icon,
		totalCountLabel = labels.Total,
		counterDetails = [new CountDetail('open', 0)],
		counterChipClassName = '', // used in template Card.
		customDetailSection = null,
		chipCount = null,
		barChartColors = ['grey300', 'green300', 'green500', 'green700'],
		barChartTooltipTitle = counterId,
		counterTitle = counterId,
		displayTotal = true
	}) {
		this.counterId = counterId;
		this.icon = icon;
		this.counterDetails = counterDetails;
		this.totalCountLabel = totalCountLabel;
		this.totalCount = 0;
		this.counterChipClassName = counterChipClassName;
		this.customDetailSection = customDetailSection;
		this.chipCount = chipCount;
		this.barChartColors = barChartColors;
		this.barChartTooltipTitle = barChartTooltipTitle;
		this.counterTitle = counterTitle;
		this.displayTotal = displayTotal;
	}

	calculateTotal() {
		let total = 0;
		this.counterDetails.forEach((a) => (total += a.count));
		this.totalCount = total;
		return this.totalCount;
	}
	// get getCounterComponent() {
	// 	return (
	// 		<MotifChip key={this.counterId} title={this.counterTitle}>
	// 			{this.icon || <SVGICONS styleName="small navTask" name="nav-Task" />}
	// 			&nbsp;
	// 			{this.chipCount || this.calculateTotal()}
	// 		</MotifChip>
	// 	);
	// }
	get getCounterDetailComponent() {
		if (this.customDetailSection !== null) {
			return this.customDetailSection;
		}

		let maxWidthOfCountLabelContainer = 100;
		if (this.counterDetails.length) {
			maxWidthOfCountLabelContainer = Math.floor(100 / this.counterDetails.length) - 1;
		}
		return (
			<DetailSection>
				{this.counterId !== undefined ? (
					<section className="row-label">
						<EllipsesControl content={this.counterId} noOfLines={1} tooltip={this.counterId} />
					</section>
				) : null}
				<TaskDetailSection>
					<section className={`totalCount ${this.displayTotal ? '' : 'hideTotalAndVerticalDivider'}`}>
						<EllipsesControl content={this.totalCountLabel} noOfLines={2} tooltip={this.totalCountLabel} />
						<Count>{this.calculateTotal()}</Count>
					</section>
					<section className={`vertical-divider ${this.displayTotal ? '' : 'hideTotalAndVerticalDivider'}`} />
					<section className="counters-section">
						{this.counterDetails.map((a) => (
							<section
								className="CountAndLabelContainer"
								style={{width: `${maxWidthOfCountLabelContainer}%`}}
								key={this.totalCountLabel + a.label}
							>
								<EllipsesControl content={a.label} noOfLines={1} tooltip={a.label} />
								<Count>{a.count}</Count>
							</section>
						))}
					</section>
				</TaskDetailSection>
				{/* <MotifTooltip
					hideCloseButton
					placement={'bottom'}
					allowClick={false}
					className={'chartTooltip'}
					trigger={
						<StackedBarChart
							theme={document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'dark' ? 'dark' : 'light'}
							chartType={'stackedBarChart'}
							chartData={this.getChartData()}
							key={'ProgressItem'}
						/>
					}
				>
					<TaskDetailSection className="chartTooltip">
						<span className="chartTooltipTitle">{this.barChartTooltipTitle}</span>
						<section className="counters-section-tooltip">
							{this.counterDetails.map((a) => (
								<section>
									<Count className="tooltipCount">{getPercent(a.count, this.totalCount)}%</Count>
									<span>{a.label}</span>
								</section>
							))}
						</section>
					</TaskDetailSection>
				</MotifTooltip> */}
			</DetailSection>
		);
	}

	// getChartData = () => {
	// 	let barItems = [];

	// 	const seriesData = this.counterDetails.map((a, i) => ({
	// 		label: a.label,
	// 		itemCount: a.count,
	// 		color: theme.color[`${this.barChartColors[i]}`],
	// 		toolTip: a.label + ' - ' + getPercent(a.count, this.totalCount) + '%'
	// 	}));

	// 	seriesData.forEach((item) => {
	// 		let seriesItem = item;
	// 		seriesItem = _.extend(seriesItem, {
	// 			count: item.itemCount,
	// 			label: item.label,
	// 			color: item.color,
	// 			toolTip: item.toolTip
	// 		});
	// 		barItems.push(seriesItem);
	// 	});
	// 	const barStyling = {
	// 		styleName: 'taskStatusBarChart',
	// 		chartWrapper: 'taskStatusBarChartWrapper',
	// 		chartHeight: 20
	// 	};

	// 	return {
	// 		barStyling: barStyling,
	// 		barMaxValue: this.totalCount,
	// 		showBarTitleTip: false,
	// 		barItems: barItems,
	// 		showCustomLegend: false,
	// 		totalCount: this.totalCount,
	// 		showChartSeries: true,
	// 		disableHover: true
	// 	};
	// };
}

export class CountDetail {
	constructor(label, count = 0) {
		this.label = label;
		this.count = count;
	}
}

export function reducerTemplateCard(state, action) {
	const isValidCardId = () => (state.has(action.payload.cardId) ? true : false);
	const p = action.payload;

	switch (action.type) {
		case 'updateCounter': {
			const p = action.payload;
			if (isValidCardId()) {
				let tempState = new Map(state);
				let card = tempState.get(action.payload.cardId);
				card.updateCounters(p.counterId, p.updatedCounts);
				tempState.set(p.cardId, card);
				return tempState;
			}
			console.log('Invalid id passed to updateCounter action');
			return state;
		}
		case 'addCard': {
			let tempState = new Map(state);
			tempState.set(action.payload.cardId, new TemplateCardConfig({title: action.payload.title}));
			return tempState;
		}
		case 'addCounter': {
			if (isValidCardId()) {
				let tempState = new Map(state);
				let card = tempState.get(action.payload.cardId);
				card.addCounter(p.templateCardCounter);
				tempState.set(p.cardId, card);
				return tempState;
			}
			return state;
		}
		case 'setIsLoading': {
			if (isValidCardId()) {
				let tempState = new Map(state);
				let card = tempState.get(action.payload.cardId);
				card.setIsLoading(p.isLoading);
				tempState.set(p.cardId, card);
				return tempState;
			}

			return state;
		}
		default:
			return state;
	}
}

const TaskDetailSection = styled.section`
	display: inline-flex;
	gap: var(--px-2);
	font-size: var(--px-12);
	min-height: var(--px-60);
	padding: var(--px-6) 0;
	align-items: stretch;
	line-height: var(--px-25);
	.totalCount {
		font-weight: normal;
		float: left;
		max-width: var(--px-80);
		min-width: var(--px-60);
		align-self: flex-end;
		span {
			font-size: var(--px-12);
			color: var(--neutrals-700);
		}
	}
	.hideTotalAndVerticalDivider {
		display: none;
	}
	.vertical-divider {
		border-left: var(--px-1) solid var(--neutrals-200);
		margin: 0 var(--px-12);
		float: left;
	}

	.counters-section {
		color: var(--neutrals-700);
		font-weight: 400;
		flex-grow: 1;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	&.chartTooltip {
		display: flex;
		padding: var(--px-10) var(--px-7) var(--px-10) var(--px-15);
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;

		font-weight: normal;
		.chartTooltipTitle {
		}
		.counters-section-tooltip {
			gap: var(--px-16);
			padding: 0 var(--px-10);
			flex-grow: 1;
			display: flex;
			justify-content: space-between;
			.tooltipCount {
				color: var(--maroon-500);
				line-height: var(--px-24);
			}
		}
	}
`;
const Count = styled.section`
	font-size: var(--px-18);
	font-weight: normal;
	color: var(--neutrals-900);
`;

const Divider = styled.section`
	border-top: var(--px-1) solid var(--neutrals-200);
	margin-top: var(--px-16);
	margin-bottom: var(--px-8);
	width: 100%;
`;

const DetailSection = styled.section`
	display: flex;
	flex-direction: column;
	/* gap: var(--px-10); */
	.row-label {
		font-size: var(--px-12);
		font-weight: 600;
		line-height: normal;
		/* margin-top: var(--px-10); */
	}
	.motif-tooltip-trigger-wrap {
		display: block !important;
	}
`;
